<div *ngIf="!passwordConfirmed" class="text-center">
    <form [formGroup]="confirmPassFormGroup" autocomplete="off">
        <div class="header-block connect-common-page-header padding-bottom-10 ">
            <h2 class="header-text semi-bold-font">Verify Password</h2>
        </div>
        <div>
            <mat-form-field appearance="legacy" class="password-mat-field">
                <mat-label>Please enter your current password</mat-label>
                <input matInput [type]="!isCurrentPasswordVisible ? 'password' : 'text'" formControlName="currentPassword" required autocomplete="off">
                <span mat-icon-button matSuffix class="cursor-pointer" (click)="isCurrentPasswordVisible = !isCurrentPasswordVisible" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="!isCurrentPasswordVisible">
                    <mat-icon>{{!isCurrentPasswordVisible ? 'visibility_off' : 'visibility'}}</mat-icon>
                </span>
                <mat-error>Please enter your current password</mat-error>
            </mat-form-field>
        </div>
        <div class="padding-top-20">
            <button mat-button
                    type="submit"
                    class="unity-btn-bg"
                    [disabled]="!isSubmitPasswordBtnEnabled()"
                    (click)="submitPassword()"
                >Next<span class="padding-left-10"><i class="fa fa-chevron-right"></i></span>
            </button>
        </div>
    </form>
</div>

<div *ngIf="passwordConfirmed">
    <mat-tab-group (selectedTabChange)="clearPassword()">
        <mat-tab label="Change my Email">
            <form [formGroup]="changeEmailFormGroup" autocomplete="off" class="text-center">
                <div class="padding-top-20">
                    <mat-form-field appearance="legacy" class="width-50">
                        <mat-label>New Email</mat-label>
                        <input matInput type="text" formControlName="newEmail" required autocomplete="off">
                        <mat-error *ngIf="changeEmailFormGroup.controls['newEmail'].errors?.required">Email is required</mat-error>
                        <mat-error *ngIf="changeEmailFormGroup.controls['newEmail'].errors?.email">Email must be a valid email</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="legacy" class="width-50">
                        <mat-label>Retype Email</mat-label>
                        <input matInput type="text" formControlName="retypeEmail" required autocomplete="off">
                        <mat-error *ngIf="changeEmailFormGroup.controls['retypeEmail'].errors?.required">Email is required</mat-error>
                        <mat-error *ngIf="changeEmailFormGroup.controls['retypeEmail'].errors?.email">Email must be a valid email</mat-error>
                        <mat-error *ngIf="changeEmailFormGroup?.controls['retypeEmail']?.hasError('mustMatch')">Emails don't match.</mat-error>
                    </mat-form-field>
                </div>
                <div class="padding-top-20">
                    <button mat-button
                            type="submit"
                            class="unity-btn-bg"
                            [disabled]="!isSubmitEmailBtnEnabled()"
                            (click)="updateUserEmail()"
                    >Change Email<span class="padding-left-10"><i class="fa fa-chevron-right"></i></span>
                    </button>
                </div>
            </form>
        </mat-tab>
        <mat-tab label="Change my Password" >
            <form [formGroup]="changePassFormGroup" autocomplete="off" class="text-center">
                <div class="padding-top-20">
                    <mat-form-field appearance="legacy" class="width-50">
                        <mat-label>New Password</mat-label>
                        <input matInput [type]="!isNewPasswordVisible ? 'password' : 'text'" formControlName="newPassword" required autocomplete="off">
                        <span mat-icon-button matSuffix class="cursor-pointer" (click)="isNewPasswordVisible = !isNewPasswordVisible" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="!isNewPasswordVisible">
                    <mat-icon>{{!isNewPasswordVisible ? 'visibility_off' : 'visibility'}}</mat-icon>
                </span>
                        <mat-error *ngIf="changePassFormGroup.controls['newPassword'].hasError('required')">Password is required</mat-error>
                        <mat-error *ngIf="changePassFormGroup.controls['newPassword'].hasError('hasNumber')">Must have at least one number!.</mat-error>
                        <mat-error *ngIf="changePassFormGroup.controls['newPassword'].hasError('hasSpecial')">Must have at least one special character.</mat-error>
                        <mat-error *ngIf="changePassFormGroup.controls['newPassword'].hasError('hasCapitalCase')">Must have at least one uppercase letter.</mat-error>
                        <mat-error *ngIf="changePassFormGroup.controls['newPassword'].hasError('minLength')">Must be at least 8 characters in length or greater.</mat-error>
                        <mat-error *ngIf="changePassFormGroup.controls['newPassword'].hasError('allowedChar')">No spaces allowed.</mat-error>
                        <mat-error *ngIf="changePassFormGroup.controls['newPassword'].hasError('allowedChar')">Allowed characters are: A to Z, a to z, 0 to 9 and special characters.</mat-error>
                        <mat-error *ngIf="changePassFormGroup.controls['newPassword'].hasError('hasConsecutive')">Password cannot have more than 2 consecutive same letter, number or special character.</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="legacy" class="width-50">
                        <mat-label>Confirm Password</mat-label>
                        <input matInput [type]="!isRetypePasswordVisible ? 'password' : 'text'" formControlName="retypePassword" required autocomplete="off">
                        <span mat-icon-button matSuffix class="cursor-pointer" (click)="isRetypePasswordVisible = !isRetypePasswordVisible" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="!isRetypePasswordVisible">
                    <mat-icon>{{!isRetypePasswordVisible ? 'visibility_off' : 'visibility'}}</mat-icon>
                </span>
                        <mat-error *ngIf="changePassFormGroup?.controls['retypePassword']?.errors?.required">Confirm password is required</mat-error>
                        <mat-error *ngIf="changePassFormGroup?.controls['retypePassword']?.hasError('mustMatch')">Passwords don't match</mat-error>
                    </mat-form-field>
                </div>
                <div class="padding-top-20">
                    <button mat-button
                            type="submit"
                            class="unity-btn-bg"
                            [disabled]="!isChangePasswordBtnEnabled()"
                            (click)="changePassword()"
                    >Change Password<span class="padding-left-10"><i class="fa fa-chevron-right"></i></span>
                    </button>
                </div>
            </form>
        </mat-tab>
    </mat-tab-group>
</div>